export const BRANDED_LOADER_ICON_POOL = [
  "croissant",
  "coffee",
  "smoothie",
  "tomato",
  "cookie",
  "pizza",
  "burrito",
  "grapes",
  "ice-cream-cone",
  "milk",
  "broccoli",
  "cake-slice",
  "hot-dog",
  "omelet",
  "pineapple",
  "taco",
  "smooth-soup-bowl",
  "bread-loaf",
  "mushroom",
  "apple",
  "banana",
  "orange",
  "strawberry",
  "watermelon",
  "carrot",
  "cucumber",
  "leafy-greens",
  "bell-pepper",
  "garlic",
  "steak",
  "poultry-leg",
  "fish-fillet",
  "salad-bowl",
  "sandwich",
] as const;

export type BrandedLoaderIconSlug = (typeof BRANDED_LOADER_ICON_POOL)[number];
